import React from "react";
// Assets
import genericUserImage  from "@/assets/avatars/avatar-generic.webp";
{
  /* TODO: Definir en la integración del backend como mostrar esto */
}
export default function People({ info, people }) {
  return (
    <div className="flex items-center -space-x-4 mb-1">

        {/*Mostrar hasta 5 seguidores y mostrar primero los que no tienen null en la imagen de perfil */}
        {[...people]
          .sort((a, b) => {
            if (a.imgPerfil && !b.imgPerfil) return -1;
            if (!a.imgPerfil && b.imgPerfil) return 1;
            return 0;
          })
          .slice(0, 5)
          .map((person, index) => (
            <img
              key={index}
              src={person.imgPerfil === null ? genericUserImage : person.imgPerfil}
              title={`${person.nombre} ${person.apellido}`}
              alt={`${person.nombre} ${person.apellido}`}
              className="w-10 h-10 rounded-full border-2 border-white object-cover shadow -ml-1 sm:ml-0 bg-aw-bluegray"
              style={{ zIndex: 10 - index }}
            />
          ))}
      <span className="ml-6 text-gray-200 text-sm font-semibold">
        {people.length} {info?.myself ? "Seguidores" : "Embajadores"}
      </span>
    </div>
  );
}
